import React, { useEffect, useState } from 'react';
import HotelImagesGallery from './preview/HotelImages';
import '../../stylesheets/zitoneo-web-preview.scss';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import { useZitoneoPreview } from '../../contexts/ZitoneoContentContext';
import CategorySection from './preview/CategorySection';
// import LanguageMenu from './preview/LanguageMenu';
import Hero from './preview/Hero';
import OverviewSection from './preview/OverviewSection';
import { Alert } from '@mui/material';
import useTranslate from '../../../../customHooks/useTranslate';
import RoomTypesList from './preview/RoomTypesList';
import Image from '../../../components/Image';

const PreviewView = () => {
    const { previewMode } = useZitoneoUI();
    const { ServiceCategories, hasUnsavedChanges, LogoFile, Name } =
        useZitoneoPreview();
    const [isMessageVisible, setIsMessageVisible] = useState(false);
    const translate = useTranslate();

    useEffect(() => {
        setIsMessageVisible(hasUnsavedChanges);
    }, [hasUnsavedChanges]);

    return (
        <div className={`preview-view__container --${previewMode}`}>
            {hasUnsavedChanges && isMessageVisible && (
                <Alert
                    severity='info'
                    onClose={() => setIsMessageVisible(false)}
                    className='preview-mode-message'
                >
                    {translate('preview_unsaved_warning')}
                </Alert>
            )}

            <div className='zitoneo-web-preview'>
                {LogoFile?.VirtualPath ? (
                    <header className='zitoneo-web-preview__header'>
                        <Image
                            src={LogoFile?.VirtualPath || ''}
                            alt='Hotel Logo'
                            useLocalBaseUrl={true}
                        />
                    </header>
                ) : (
                    ''
                )}

                <main className='zitoneo-web-preview__content'>
                    <Hero />
                    <HotelImagesGallery />

                    <OverviewSection />
                    {ServiceCategories.map(category => {
                        return (
                            <CategorySection
                                key={category.Id}
                                category={category}
                            />
                        );
                    })}
                    <RoomTypesList />
                </main>
                <footer className='zitoneo-web-preview__footer'>
                    <p>
                        &copy; {new Date().getFullYear()} {Name}.{' '}
                        {translate('all_rights_reserved')}
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default PreviewView;
